// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1fTmz","buttons":"RemoveExpirationActionButtons_buttons__3gsYw"};